import { version as appVersion } from '../../package.json'
import { trpc } from '../system/trpc'

export async function getVersion() {
    const data = await trpc.utils.getVersion.query()
    // Return the full version data object for enhanced version checking
    return data
}
